module.exports = __webpack_public_path__ + "img/icon-info.26a3da85.svg";